export default "__VITE_PUBLIC_ASSET__4b380426__"